// SystemChips - one checkbox per drawn system, with its colour and what the
// received drawings cover. The overview and the zone page share them, and
// the zone page's address carries the same ids (`sys=`).
import React from "react";
import { drawnSystems, systemColor } from "./glanceModel";

export default function SystemChips({ manifest, active, onChange, compact = false }) {
  const systems = drawnSystems(manifest);
  if (!systems.length) return null;
  const toggle = (id) => {
    const next = new Set(active);
    if (next.has(id)) next.delete(id); else next.add(id);
    onChange(next);
  };
  return (
    <div className="g-chips" role="group" aria-label="Systems shown">
      {systems.map((s) => (
        <label key={s.id} title={[s.band, s.source].filter(Boolean).join(" | ")}>
          <input type="checkbox" checked={active.has(s.id)} onChange={() => toggle(s.id)} />
          <i style={{ background: systemColor(s) }} />
          {s.label}
          {!compact && <small>{s.coverage ? s.coverage.note || "Part of the building" : "All floors"}</small>}
        </label>
      ))}
    </div>
  );
}
